<template>
  <pre data-module="global-menu">{{ $props }}</pre>
</template>

<script>
export default {
  name: 'GlobalMenu',
  props: {
    menuLinks: {
      type: Array,
      default() {
        return [
          {
            linkText: 'Promoções',
            linkUrl: {
              type: 'externalLink',
              value: '',
              openInNewTab: true,
            },
            id: 'DefaultUneditedId',
            menuLinks: [],
          },
        ];
      },
    },
  },
  metadata: {
    tabs: [
      {
        name: 'menu',
        label: 'Menu',
        fields: [
          {
            name: 'title',
            targetProperty: null,
            type: 'ShortText',
            label: 'Nome do menu global',
            validate({ title, language, getters: { menus } }) {
              if (!title) {
                return {
                  error: '<b>Digite um nome</b> para o menu global',
                };
              }

              const duplicatedTitle =
                Object.values(menus).filter(
                  (menuItem) =>
                    title === menuItem.title && language === menuItem.language,
                ).length > 1;

              if (duplicatedTitle) {
                return {
                  error:
                    'Este <b>nome já está sendo usado</b> para um menu do mesmo idioma',
                };
              }

              return { error: false };
            },
          },
          {
            name: 'language',
            targetProperty: null,
            type: 'VueSelect',
            label: 'Idioma do menu global',
            // helpText: 'Caso mude a linguagem do menu global, ele não estará mais
            // acessível para as páginas do seu idioma anterior. Será tratado como deletado.',
            options: [
              {
                label: 'Selecione um idioma',
                value: '',
              },
              {
                label: 'Português',
                value: 'pt',
              },
              {
                label: 'Inglês',
                value: 'en',
              },
              {
                label: 'Espanhol',
                value: 'es',
              },
            ],
            isEnabled({ instance: { id }, page }) {
              return id.includes('Creating') && !page.id;
            },
            validate({ language }) {
              if (!language) {
                return { error: 'Selecione um idioma para este menu' };
              }

              return { error: false };
            },
          },
          {
            name: 'menuLinks',
            type: 'Menu',
          },
        ],
      },
    ],
  },
};
</script>
